/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmConversationsGetItem } from "../../funcs/llmConversationsGetItem.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ConversationsItemsRetrieveRequest$inboundSchema,
};

export const tool$llmConversationsGetItem: ToolDefinition<typeof args> = {
  name: "llm-conversations-get-item",
  description: `Retrieve a conversation item

Get a single item from a conversation with the given IDs.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmConversationsGetItem(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
